<template>
  <section id="orderSummary" class="checkout-section transparent">
    <div class="cost-details">
      <div class="cost-detail-row">
        <span>{{ resources.subtotalLabel }}</span>
        <span>{{ orderSubtotal }}</span>
      </div>
      <div v-if="shouldShowCouponCode" class="cost-detail-row">
        <coupon-form />
      </div>
      <eurobonus-form />
      <div class="cost-detail-row" v-if="giftCardDeductionAmountValue > 0">
        <span>{{ resources.giftCardsLabel }}</span>
        <span>{{ giftCardDeductionAmount }}</span>
      </div>
      <div class="cost-detail-row" v-if="giftWrapAndGreetCardPriceValue > 0">
        <span>{{ resources.giftWrapAndGreetCardLabel }}</span>
        <span>{{ giftWrapAndGreetCardPrice }}</span>
      </div>
      <div class="cost-detail-row">
        <span>{{ resources.deliveryLabel }}</span>
        <span>{{ shippingPrice }}</span>
      </div>
      <div class="cost-detail-row">
        <span>
          {{ resources.totalLabel }}
          <span class="taxes-included">{{ resources.taxesLabel }}</span>
        </span>
        <span>{{ orderTotalsPrice }}</span>
      </div>
    </div>
  </section>
</template>

<script src='./order-summary.js'></script>
